import { render } from "./DrugAlerts.vue?vue&type=template&id=54f28234"
import script from "./DrugAlerts.vue?vue&type=script&lang=js"
export * from "./DrugAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__